import { css } from "@microsoft/fast-element";
import { display } from "../../foundation/display";

export const accordionStyles = css`
        ${display("flex")}

        :host {
            display: flex;
            box-sizing: border-box;
            flex-direction: column;
            position: relative;
        }
    `;
